// if (!customElements.get('product-form')) {
//   customElements.define(
//     'product-form',
//     class ProductForm extends HTMLElement {
//       constructor() {
//         super();

//         this.form = this.querySelector('form');
//         this.variantIdInput.disabled = false;
//         this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
//         this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
//         this.submitButton = this.querySelector('[type="submit"]');
//         this.submitButtonText = this.submitButton.querySelector('span');

//         if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

//         this.hideErrors = this.dataset.hideErrors === 'true';
//       }

//       onSubmitHandler(evt) {
//         evt.preventDefault();
//         if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

//         this.handleErrorMessage();

//         this.submitButton.setAttribute('aria-disabled', true);
//         this.submitButton.classList.add('loading');
//         this.querySelector('.loading__spinner').classList.remove('hidden');


//         // Added ByMLVEda:start

//         if (window.location.pathname !== '/cart') customCartOpen(true);
//         this.querySelector('#product-text').classList.add('hidden');
//         this.querySelector('#product-added-text').classList.add('visible');
//         // Added ByMLVEda:end

//         const config = fetchConfig('javascript');
//         config.headers['X-Requested-With'] = 'XMLHttpRequest';
//         delete config.headers['Content-Type'];

//         const formData = new FormData(this.form);
//         if (this.cart) {
//           formData.append(
//             'sections',
//             this.cart.getSectionsToRender().map((section) => section.id)
//           );
//           // if(window.location.pathname == '/cart'){

//           //     formData.append('sections',{id: 'main-cart-items', selector: "#shopify-section-template--25466942718318__cart-items", id: 'main-cart-footer', selector: '#shopify-section-template--25466942718318__cart-footer'})   

//           // }
//           formData.append('sections_url', window.location.pathname);
//           this.cart.setActiveElement(document.activeElement);
//         }
//         config.body = formData;

//         fetch(`${routes.cart_add_url}`, config)
//           .then((response) => response.json())
//           .then((response) => {
//             if (response.status) {
//               publish(PUB_SUB_EVENTS.cartError, {
//                 source: 'product-form',
//                 productVariantId: formData.get('id'),
//                 errors: response.errors || response.description,
//                 message: response.message,
//               });
//               this.handleErrorMessage(response.description);


//               if (window.location.pathname !== '/cart') {
//                 fetch(`${routes.cart_url}?section_id=cart-drawer`)
//                   .then((response) => response.text())
//                   .then((responseText) => {
//                     const html = new DOMParser().parseFromString(responseText, 'text/html');
//                     // const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
//                     const selectors = ['#CartDrawer'];
//                     for (const selector of selectors) {
//                       const targetElement = document.querySelector(selector);
//                       const sourceElement = html.querySelector(selector);
//                       if (targetElement && sourceElement) {
//                         // targetElement.replaceWith(sourceElement);
//                         targetElement.innerHTML = sourceElement.innerHTML;
//                       }
//                     }
//                     updateCartBubble();
//                     document.querySelectorAll("cart-drawer .quantity__input").forEach((input) => {

//                       handleQuantity(input);
//                     });
//                     updateCartBubble();

//                   })
//                   .catch((e) => {
//                     console.error(e);
//                   });
//               }
//               else {
//                 fetch(`${routes.cart_url}?section_id=main-cart-items`)
//                   .then((response) => response.text())
//                   .then((responseText) => {
//                     const html = new DOMParser().parseFromString(responseText, 'text/html');
//                     const sourceQty = html.querySelector('cart-items');
//                     document.querySelector('cart-items').innerHTML = sourceQty.innerHTML;
//                     this.querySelectorAll(".quantity__input").forEach((input) => {

//                       handleQuantity(input);
//                     });
//                     updateCartBubble();
//                     fetchAndUpdateSection({
//                       id: 'main-cart-footer',
//                       section: document.getElementById('main-cart-footer').dataset.id,
//                       selector: '.js-contents-2'
//                     });
//                   })
//                   .catch((e) => {
//                     console.error(e);
//                   });
//               }



//               const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
//               if (!soldOutMessage) return;
//               this.submitButton.setAttribute('aria-disabled', true);
//               this.submitButtonText.classList.add('hidden');
//               soldOutMessage.classList.remove('hidden');
//               this.error = true;

//               return;
//             } else if (window.location.pathname == '/cart') {

//               console.log('INside cart')

//               // return;

//             } else if (!this.cart) {
//               window.location = window.routes.cart_url;
//               return;
//             }

//             const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
//             if (!this.error)
//               publish(PUB_SUB_EVENTS.cartUpdate, {
//                 source: 'product-form',
//                 productVariantId: formData.get('id'),
//                 cartData: response,
//               }).then(() => {
//                 CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
//               });
//             this.error = false;
//             const quickAddModal = this.closest('quick-add-modal');
//             if (quickAddModal) {
//               document.body.addEventListener(
//                 'modalClosed',
//                 () => {
//                   setTimeout(() => {
//                     CartPerformance.measure("add:paint-updated-sections", () => {

//                       // this.cart.renderContents(response);
//                       document.querySelectorAll(".quantity__input").forEach((input) => {

//                         handleQuantity(input);
//                       });
//                       updateCartBubble();
//                     });
//                   });
//                 },
//                 { once: true }
//               );
//               // quickAddModal.hide(true);
//             } else {
//               CartPerformance.measure("add:paint-updated-sections", () => {


//                 this.cart.renderContents(response);
//                 document.querySelectorAll(".quantity__input").forEach((input) => {

//                   handleQuantity(input);
//                 });
//                 updateCartBubble();
//               });
//             }
//           })
//           .catch((e) => {
//             console.error(e);
//           })
//           .finally(() => {
//             this.submitButton.classList.remove('loading');
//             if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
//             if (!this.error) this.submitButton.removeAttribute('aria-disabled');
//             this.querySelector('.loading__spinner').classList.add('hidden');

//             // added By MLVeda:start

//             this.querySelector('#product-text').classList.remove('hidden');

//             this.querySelector('#product-added-text').classList.remove('visible');

//             // added By MLVeda:end
//             CartPerformance.measureFromEvent("add:user-action", evt);
//           });
//       }

//       handleErrorMessage(errorMessage = false) {
//         if (this.hideErrors) return;

//         this.errorMessageWrapper =
//           this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper') || this.parentElement?.parentElement?.parentElement?.querySelector('.product-form__error-message-wrapper');
//         if (!this.errorMessageWrapper) return;
//         this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

//         this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

//         if (errorMessage) {
//           this.errorMessage.textContent = errorMessage;
//         }
//       }

//       toggleSubmitButton(disable = true, text) {
//         if (disable) {
//           this.submitButton.setAttribute('disabled', 'disabled');
//           if (text) this.submitButtonText.textContent = text;
//         } else {
//           this.submitButton.removeAttribute('disabled');
//           this.submitButtonText.textContent = window.variantStrings.addToCart;
//         }
//       }

//       get variantIdInput() {
//         return this.form.querySelector('[name=id]');
//       }
//     }
//   );
// }



if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

         // Added ByMLVEda:start
        if (window.location.pathname !== '/cart') customCartOpen(true);
        this.querySelector('#product-text').classList.add('hidden');
        this.querySelector('#product-added-text').classList.add('visible');
        // Added ByMLVEda:end


        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              if(response.status == 422 && response.description != 'The maximum quantity of this item is already in your cart.'){
                if (window.location.pathname !== '/cart') {
                  fetch(`${routes.cart_url}?section_id=cart-drawer`)
                    .then(response => response.text())
                    .then(responseText => {
                      const html = new DOMParser().parseFromString(
                        responseText,
                        'text/html'
                      );
                      const selectors = [
                        '#CartDrawer'
                      ];
                      for (const selector of selectors) {
                        const targetElement = document.querySelector(selector);
                        const sourceElement = html.querySelector(selector);
                        if (targetElement && sourceElement) {
                          targetElement.replaceWith(sourceElement);
                        }
                      }
                      document.querySelectorAll(".quantity__input").forEach((input) => {
                        handleQuantity(input);
                      });
                      updateCartBubble();
                      needToRender = false;
                    })
                    .catch(e => {
                      console.error(e);
                    });
                } else {
                  fetch(`${routes.cart_url}?section_id=main-cart-items`)
                    .then(response => response.text())
                    .then(responseText => {
                      const html = new DOMParser().parseFromString(
                        responseText,
                        'text/html'
                      );
                      const sourceQty = html.querySelector('cart-items');
                      document.querySelector('cart-items').innerHTML =
                        sourceQty.innerHTML;
                      this.querySelectorAll('.quantity__input').forEach(input => {
                        handleQuantity(input);
                      });
                      updateCartBubble();
                      fetchAndUpdateSection({
                        id: 'main-cart-footer',
                        section:
                          document.getElementById('main-cart-footer').dataset.id,
                        selector: '.js-contents-2',
                      });
                    })
                    .catch(e => {
                      console.error(e);
                    });
                }
              }
              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                     
                      this.cart.renderContents(response , needToRender);

                    });
                  });
                },
                { once: true }
              );
              // Commented by MLVeda :Start
              // quickAddModal.hide(true);
              // Commented by MLVeda :End

            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            // added By MLVeda:start
            this.querySelector('#product-text').classList.remove('hidden');
            this.querySelector('#product-added-text').classList.remove('visible');
            // added By MLVeda:end

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        // Commented by MLVeda :Start
        // this.errorMessageWrapper =
        //   this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        // Commented by MLVeda :End

        // Added by MLVeda : Start
        this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper') || this.parentElement?.parentElement?.parentElement?.querySelector('.product-form__error-message-wrapper');
        // Added by MLVeda :End

        
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
